import https from "./https"
import store from "@/store"

const order = {
  getOrders(params) {
    const organization = store.state.general.organization
    return https.get('admin/organizations/' + organization.id + '/orders', {params})
  },
  getOrder(id) {
    const organization = store.state.general.organization
    return https.get('admin/organizations/' + organization.id + '/orders/' + id)
  },
  updateOrder(id, params) {
    const organization = store.state.general.organization
    return https.put('admin/organizations/' + organization.id + '/orders/' + id, params)
  },
  createOrder(params) {
    const organization = store.state.general.organization
    return https.post('admin/organizations/' + organization.id + '/orders/', params)
  },
  deleteOrder(id) {
    const organization = store.state.general.organization
    return https.delete('admin/organizations/' + organization.id + '/orders/' + id)
  },
  convertOrderToPoints() {
    const organization = store.state.general.organization
    return https.post('admin/organizations/' + organization.id + '/orders/convert-to-points')
  },
  assignCustomer(orderId, customerId) {
    const organization = store.state.general.organization
    return https.put(
      `admin/organizations/${organization.id}/orders/${orderId}/assign-customer`,
      { customer_id: customerId }
    )
  },
  deleteOrderPoints(orderId) {
    const organization = store.state.general.organization
    return https.delete(`admin/organizations/${organization.id}/orders/${orderId}/points`)
  },
  exportOrders(params) {
    const organization = store.state.general.organization
    return https.get(`admin/organizations/${organization.id}/orders/export`, { params })
  },
  exportOrdersCsv(params) {
    const organization = store.state.general.organization
    return https.get(`admin/organizations/${organization.id}/orders/export-csv`, { params })
  },
  exportFailedOrders(merchantID, data) {
    const organization = store.state.general.organization;
    return https.post(
      `/admin/organizations/${organization.id}/orders/merchants/${merchantID}/export-failed-orders`,
      data
    );
  },
}

export default order
